module.exports = new __parcel__URL__("pvp_heavy_attack_button.bded1cec.png").toString();